import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, IconButton, Divider, ListItemIcon } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import api from './api';
import { useUser } from './UserContext';

const Header = () => {
  const { user, setUser } = useUser();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettings = () => {
    navigate('/settings');
    handleClose();
  };

  const handleMonitor = () => {
    navigate('/monitor');
    handleClose();
  };

  const handleBillingPortal = async () => {
    handleClose();
    const win = window.open('', '_blank');
    try {
      const res = await api.get('/user/portal');
      if (res.data?.result?.url) {
        win.location.href = res.data.result.url;
      } else {
        win.close();
      }
    } catch (err) {
      console.error('Billing portal error:', err);
      win.close();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(undefined);
    navigate('/');
    handleClose();
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Typography variant="h6">
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              Snapperish
            </Link>
          </Typography>
          {user && (
            <Button color="inherit" component={Link} to="/dashboard">
              Dashboard
            </Button>
          )}
        </div>
        <div>
          {user ? (
            <>
              <IconButton color="inherit" onClick={handleMenuClick}>
                <Typography variant="body1" sx={{marginRight:1}}>
                  {user.userFullName}
                </Typography>
                <AccountCircleIcon />
              </IconButton>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem disabled>{user.userFullName}</MenuItem>
                <Divider />
                {user.isSysAdmin && (
                  <MenuItem onClick={handleMonitor}>
                    <ListItemIcon sx={{ color: 'inherit' }}>
                      <CameraAltIcon fontSize="small" />
                    </ListItemIcon>
                    Monitor
                  </MenuItem>
                )}
                {user.userStripeCustomerId && (
                  <MenuItem onClick={handleBillingPortal}>
                    <ListItemIcon sx={{ color: 'inherit' }}>
                      <CreditCardIcon fontSize="small" />
                    </ListItemIcon>
                    Manage Billing
                  </MenuItem>
                )}
                <MenuItem onClick={handleSettings}>
                  <ListItemIcon sx={{ color: 'inherit' }}>
                    <SettingsIcon fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon sx={{ color: 'inherit' }}>
                    <ExitToAppIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              {process.env.REACT_APP_COMING_SOON !== 'true' && (
                <>
                  <Button color="inherit" component={Link} to="/login">
                    Login
                  </Button>
                  <Button color="inherit" component={Link} to="/signup">
                    Sign Up
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;